<script>
import { Popover } from 'element-ui';

export default {
  extends: Popover,
};
</script>

<style lang="scss">
  .el-popover {
    background: #f4f9fb;
    border-color: #c9dfed;
  }
</style>
